var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from 'hx-util';
export function ContentBlock(_a) {
    var children = _a.children, className = _a.className;
    return (_jsx("div", __assign({ className: cn('bg-faux-white justify-between shadow py-10 px-4 md:p-10 rounded-xl flex gap-y-6 items-center flex-col', className) }, { children: children })));
}
